module.exports = __webpack_public_path__ + "assets/img/ice-dam.85c4b12a.jpg";